<template>
  <div>
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="" :model="searchForm">
          <el-form-item label="批次发货编号:">
            <el-input v-model.trim="searchForm.omsBatchNum" placeholder="请输入批次发货编号" />
          </el-form-item>
          <el-form-item label="申请人:">
            <el-input v-model.trim="searchForm.applicationName" placeholder="请输入申请人" show-word-limit maxlength="30" />
          </el-form-item>
          <el-form-item label="申请时间:" prop="applicationStartTime">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.applicationStartTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.applicationEndTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="客户名称:">
            <el-input v-model.trim="searchForm.agentName" placeholder="请输入客户名称" show-word-limit maxlength="200" />
          </el-form-item>
          <el-form-item label="订单合同号:">
            <el-input v-model.trim="searchForm.contractNum" placeholder="请输入订单合同号" show-word-limit maxlength="30" />
          </el-form-item>
          <el-form-item label="下单主体:">
            <el-input v-model.trim="searchForm.businessEntity" placeholder="请输入下单主体" show-word-limit maxlength="200" />
          </el-form-item>
          <el-button type="primary" :loading="isLoading" @click="searchData">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
          <el-button type="primary" :loading="isLoading" @click="exportProduct">
            导出明细
          </el-button>
        </el-form>
      </div>
    </div>
    <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
      <el-table-column label="操作" align="left" width="120">
        <template v-slot="{ row }">
          <el-button type="text" @click="Handle(row)">办理</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="omsBatchNum" label="批次发货编号" align="left" />
      <el-table-column prop="applicationTime" label="申请时间" align="left" />
      <el-table-column prop="applicationName" label="申请人" align="left" />
      <el-table-column prop="contractNum" label="订单合同号" align="left">
        <!-- 多合同号时使用省略号并配合 Tooltip 展示完整内容 -->
        <template v-slot="{ row }">
          <el-tooltip
            v-if="shouldShowContractTooltip(row.contractNum)"
            effect="dark"
            :content="getContractTooltip(row.contractNum)"
            placement="top"
          >
            <span class="contract-ellipsis">{{ getContractDisplay(row.contractNum) }}</span>
          </el-tooltip>
          <span v-else class="contract-ellipsis">{{ getContractDisplay(row.contractNum) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="supplyUnitName" label="下单主体" align="left" />
      <el-table-column prop="agentName" label="客户名称" align="left" />
      <el-table-column prop="batchTotalAmount" label="批次发货总金额" align="left">
        <template v-slot="{ row }">
          {{ row.batchTotalAmount ? Number(row.batchTotalAmount).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="salesTypeName" label="付款方式" align="left" />
      <el-table-column prop="hopeOrderTime" label="希望开单时间" align="left" />
      <el-table-column prop="updateTime" label="最新更新时间" align="left" />
    </el-table>
    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { GetBatchList, ExportBatch } from '@/API/BatchManagement.js';
import { downloadBlobFile } from '@/libs/util';

const INVALID_CHAR_PATTERN = /[^\w\u4e00-\u9fa5\s-]/g;
export default {
  data () {
    const defaultSearchForm = {
      omsBatchNum: '',
      applicationName: '',
      applicationStartTime: '',
      applicationEndTime: '',
      completionEndTime: '',
      agentName: '',
      contractNum: '',
      businessEntity: ''
    };
    return {
      defaultSearchForm,
      searchForm: { ...defaultSearchForm },
      tableData: [],
      isLoading: false,
      pickerOptions: {
        disabledDate: () => false
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      activeFilters: {}
    };
  },
  methods: {
    Handle (row) {
      this.$router.push(
        {
          path: `/PendingBatchInfo/${row.contractNum}`,
          query: {
            id: row.id
          }
        }
      );
    },
    // 将合同号整理为列表并控制 Tooltip 展示逻辑
    shouldShowContractTooltip (contractValue) {
      const parts = this.normalizeContractList(contractValue);
      return parts.length > 1;
    },
    getContractDisplay (contractValue) {
      const parts = this.normalizeContractList(contractValue);
      if (!parts.length) return '';
      return parts.length > 1 ? `${parts[0]}...` : parts[0];
    },
    getContractTooltip (contractValue) {
      const parts = this.normalizeContractList(contractValue);
      return parts.join(' , ');
    },
    normalizeContractList (contractValue) {
      if (contractValue === null || contractValue === undefined) return [];
      if (Array.isArray(contractValue)) {
        return contractValue
          .map((item) => (item === null || item === undefined ? '' : item.toString().trim()))
          .filter(Boolean);
      }
      return contractValue
        .toString()
        .split(/[，,\n;]/)
        .map((item) => item.trim())
        .filter(Boolean);
    },
    async getData (includeFilters = true) {
      // 分页切换调用 getData(false) 时不再携带搜索条件，
      // 只在显式搜索或重置时发送完整筛选参数,保证切换页码时不触发搜索操作
      this.isLoading = true;
      try {
        const baseParams = {
          pageIndex: this.page.currentPage,
          pageSize: this.page.pageSize,
          bussinessType: 0
        };
        let filters = {};
        if (includeFilters) {
          filters = this.buildFilterParams();
          this.activeFilters = { ...filters };
        } else {
          filters = this.activeFilters || {};
        }
        const params = { ...filters, ...baseParams };
        const res = await GetBatchList(params);
        this.tableData = res.data.data.list || [];
        this.page.total = res.data.data.total || 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    searchData () {
      this.page.currentPage = 1;
      this.getData(true);
    },
    resetForm () {
      if (this.$refs.searchForm) {
        this.$refs.searchForm.resetFields();
      }
      Object.assign(this.searchForm, this.defaultSearchForm);
      this.activeFilters = {};
      this.page.currentPage = 1;
      this.getData(true);
    },
    handerSizeChange (size) {
      this.page.pageSize = size;
      this.page.currentPage = 1;
      this.getData(false);
    },
    handerCurrentChange (page) {
      this.page.currentPage = page;
      this.getData(false);
    },
    // 当搜索框输入时，移除除中文、字母、数字、下划线、空格和短横线外的符号
    buildFilterParams (source = this.searchForm) {
      const filters = {};
      Object.keys(source).forEach((key) => {
        const value = source[key];
        if (typeof value === 'string') {
          filters[key] = value ? value.replace(INVALID_CHAR_PATTERN, '') : value;
        } else {
          filters[key] = value;
        }
      });
      return filters;
    },
    exportProduct () {
      const hasActiveFilters = this.activeFilters && Object.keys(this.activeFilters).length;
      const filters = hasActiveFilters ? this.activeFilters : this.buildFilterParams();
      const params = {
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        omsBatchNum: filters.omsBatchNum,
        applicationName: filters.applicationName,
        applicationStartTime: filters.applicationStartTime,
        applicationEndTime: filters.applicationEndTime,
        agentName: filters.agentName,
        contractNum: filters.contractNum,
        supplyUnitName: filters.businessEntity,
        bussinessType: 0
      };
      ExportBatch(params).then((res) => {
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '待确认批次发货明细'
        });
      });
    }
  },
  mounted () {
    this.getData();
  }
};
</script>
<style scoped>
.contract-ellipsis {
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
